import { ISaveAsPatchContext } from './saveAsPatchModalContext';

export enum SaveAsPatchActionTypes {
	SET_INITIAL_FORM_DATA = 'SET_INITIAL_FORM_DATA',
	SET_TYPE_OF_CHANGES = 'SET_TYPE_OF_CHANGES',
	SET_IDS_RESTAURANT = 'SET_IDS_RESTAURANT',
	SET_PROPERTIES = 'SET_PROPERTIES',
	CHANGE_PRICE = 'CHANGE_PRICE',
	TOGGLE_HAS_OPEN_PRICE = 'TOGGLE_HAS_OPEN_PRICE',
	CHANGE_OPEN_PRICE = 'CHANGE_OPEN_PRICE',
	CHANGE_OPEN_PRICE_MAX_THRESHOLD = 'CHANGE_OPEN_PRICE_MAX_THRESHOLD',
	CHANGE_TAX_PERCENT = 'CHANGE_TAX_PERCENT',
	TOGGLE_IN_STOP = 'TOGGLE_IN_STOP',
	TOGGLE_IS_COMMENT_VISIBLE = 'TOGGLE_IS_COMMENT_VISIBLE',
	TOGGLE_IS_FISCALIZED = 'TOGGLE_IS_FISCALIZED',
	TOGGLE_IS_TAX_PERCENT_PROTECT_FROM_SYNC = 'TOGGLE_IS_TAX_PERCENT_PROTECT_FROM_SYNC',
	CHANGE_ACTIVATION_SCHEDULE = 'CHANGE_ACTIVATION_SCHEDULE',
	CHANGE_DEACTIVATION_SCHEDULE = 'CHANGE_DEACTIVATION_SCHEDULE',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
	RESET_FIELDS = 'RESET_FIELDS',
}

interface ISetInitialFormData {
	type: SaveAsPatchActionTypes.SET_INITIAL_FORM_DATA;
	payload: {
		initialFormData: ISaveAsPatchContext['initialFormData'];
	};
}

interface ISetTypeOfChanges {
	type: SaveAsPatchActionTypes.SET_TYPE_OF_CHANGES;
	payload: {
		typeOfChanges: ISaveAsPatchContext['typeOfChanges'];
		IDsSelectedRestaurant: ISaveAsPatchContext['IDsSelectedRestaurant'];
	};
}

interface ISetIDsRestaurant {
	type: SaveAsPatchActionTypes.SET_IDS_RESTAURANT;
	payload: {
		IDsSelectedRestaurant: ISaveAsPatchContext['IDsSelectedRestaurant'];
	};
}

interface ISetProperties {
	type: SaveAsPatchActionTypes.SET_PROPERTIES;
	payload: {
		selectedProperties: ISaveAsPatchContext['selectedProperties'];
	};
}

interface IChangePrice {
	type: SaveAsPatchActionTypes.CHANGE_PRICE;
	payload: {
		price: ISaveAsPatchContext['price'];
	};
}

interface IToggleHasOpenPrice {
	type: SaveAsPatchActionTypes.TOGGLE_HAS_OPEN_PRICE;
}

interface IChangeOpenPrice {
	type: SaveAsPatchActionTypes.CHANGE_OPEN_PRICE;
	payload: {
		openPrice: ISaveAsPatchContext['openPrice'];
	};
}

interface IChangeOpenPriceMaxThreshold {
	type: SaveAsPatchActionTypes.CHANGE_OPEN_PRICE_MAX_THRESHOLD;
	payload: {
		openPriceMaxThreshold: ISaveAsPatchContext['openPriceMaxThreshold'];
	};
}

interface IChangeTaxPercent {
	type: SaveAsPatchActionTypes.CHANGE_TAX_PERCENT;
	payload: {
		taxPercent: ISaveAsPatchContext['taxPercent'];
	};
}

interface IToggleInStop {
	type: SaveAsPatchActionTypes.TOGGLE_IN_STOP;
}

interface IToggleIsCommentVisible {
	type: SaveAsPatchActionTypes.TOGGLE_IS_COMMENT_VISIBLE;
}

interface IToggleIsFiscalized {
	type: SaveAsPatchActionTypes.TOGGLE_IS_FISCALIZED;
}

interface IToggleIsTaxPercentProtectedFromSync {
	type: SaveAsPatchActionTypes.TOGGLE_IS_TAX_PERCENT_PROTECT_FROM_SYNC;
}

interface IChangeActivationSchedule {
	type: SaveAsPatchActionTypes.CHANGE_ACTIVATION_SCHEDULE;
	payload: {
		activationSchedule: ISaveAsPatchContext['activationSchedule'];
	};
}

interface IChangeDeactivationSchedule {
	type: SaveAsPatchActionTypes.CHANGE_DEACTIVATION_SCHEDULE;
	payload: {
		deactivationSchedule: ISaveAsPatchContext['deactivationSchedule'];
	};
}

interface IChangeActivationSchedule {
	type: SaveAsPatchActionTypes.CHANGE_ACTIVATION_SCHEDULE;
	payload: {
		activationSchedule: ISaveAsPatchContext['activationSchedule'];
	};
}

interface IChangeDeactivationSchedule {
	type: SaveAsPatchActionTypes.CHANGE_DEACTIVATION_SCHEDULE;
	payload: {
		deactivationSchedule: ISaveAsPatchContext['deactivationSchedule'];
	};
}

interface IChangeTypeOfModalWindow {
	type: SaveAsPatchActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: ISaveAsPatchContext['typeOfModalWindow'];
	};
}

interface IResetFields {
	type: SaveAsPatchActionTypes.RESET_FIELDS;
}

export type TSaveAsPatchAction =
	| ISetInitialFormData
	| ISetTypeOfChanges
	| ISetIDsRestaurant
	| ISetProperties
	| IChangePrice
	| IToggleHasOpenPrice
	| IChangeOpenPrice
	| IChangeOpenPriceMaxThreshold
	| IChangeTaxPercent
	| IToggleInStop
	| IToggleIsCommentVisible
	| IToggleIsFiscalized
	| IToggleIsTaxPercentProtectedFromSync
	| IChangeActivationSchedule
	| IChangeDeactivationSchedule
	| IChangeTypeOfModalWindow
	| IResetFields;
